// extracted by mini-css-extract-plugin
export default {"verificationContainer":"pSR_bxUzvSmX7txIGPYg"};